import {
    FETCH_GARANTIAS,
    LOADING_GARANTIAS,
} from './types';

import {
    fetchGarantiasApi,
} from '../api/axios';

export const fetchGarantias = (params) => async (dispatch) => {
  const cod = params?.codProducto;
  if (cod === undefined || cod === null || String(cod).trim() === '') {
    dispatch({
      type: FETCH_GARANTIAS,
      payload: { garantias: [] },
    });
    return { garantias: [] };
  }

  dispatch({
    type: LOADING_GARANTIAS,
    payload: true,
  });
  try {
    const garantias = await fetchGarantiasApi(params);
    dispatch({
      type: FETCH_GARANTIAS,
      payload: garantias,
    });
    return garantias;
  } catch {
    dispatch({
      type: FETCH_GARANTIAS,
      payload: { garantias: [] },
    });
    return { garantias: [] };
  } finally {
    dispatch({
      type: LOADING_GARANTIAS,
      payload: false,
    });
  }
};